<script>
 import { onMount, onDestroy } from 'svelte';

 /**
  * The parsed audio wave data object.
  * Expects an object like: { data: [num, num, ...] }
  * @type {{ data: number[] }}
  */
 export let wave = { data: [] };

 let canvas;
 let container; // We need to observe the container for size changes
 let resizeObserver;

 function draw() {
     if (!canvas || !wave || !wave.data || wave.data.length === 0) {
         return;
     }

     const ctx = canvas.getContext('2d');
     if (!ctx) return;

     // --- FIX: Handle HiDPI / Retina displays to prevent blurriness ---
     const dpr = window.devicePixelRatio || 1;
     const rect = canvas.getBoundingClientRect();
     canvas.width = rect.width * dpr;
     canvas.height = rect.height * dpr;
     ctx.scale(dpr, dpr);
     
     const width = canvas.clientWidth;
     const height = canvas.clientHeight;
     const data = wave.data;

     // --- FIX: More robust drawing logic ---
     ctx.clearRect(0, 0, width, height);
     ctx.fillStyle = '#3a3a3a';

     const barWidth = width / (data.length / 2); // Calculate width based on pairs of data points
     let x = 0;

     for (let i = 0; i < data.length; i += 2) {
         const lineHeight = (Math.abs(data[i] - data[i + 1])) * height / 2;
         const y = (height - lineHeight) / 2;
         ctx.fillRect(x, y, barWidth, lineHeight);
         x += barWidth;
     }
 }

 $: if (canvas && wave) {
     draw();
 }

 onMount(() => {
     resizeObserver = new ResizeObserver(() => {
         draw();
     });

     if (container) {
         resizeObserver.observe(container);
     }
 });

 onDestroy(() => {
     if (resizeObserver && container) {
         resizeObserver.unobserve(container);
     }
 });
</script>

<div bind:this={container} class="w-full h-full absolute top-0 left-0">
    <canvas bind:this={canvas} class="w-full h-full" />
</div>
